import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { IUser } from '../../../models/User';
import { buildHttpParams } from 'src/app/helpers/build-state-params';

export interface UserModel {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  type: string;
  tenantId: string;
  logConfig?: string;
  currentDevice?: string;
  createdAt?: number;
  deletedAt?: number;
  lastSeenAt?: number;
  updatedAt?: number;
}

export interface UserByDeviceModel {
  id: string;
  firstName: string;
  lastName: string;
  currentDevice: string;
  taskCount: string;
}

interface GetAllUsersResponse {
  count: number;
  values: IUser[];
}

@Injectable({
  providedIn: 'root'
})
export class UserDataSourceService {

  constructor(private httpClient: HttpClient) { }

  async getLoggedUser(): Promise<IUser> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.httpClient.get(environment.baseUrl + '/api/v1/admin-desktop/users/me', { headers }).toPromise<any>();
  }

  async getUserTasks() {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.httpClient.get(environment.baseUrl + '/api/v1/admin-desktop/tasks', { headers }).toPromise<any>();
  }

  async getAll(): Promise<GetAllUsersResponse>{
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.httpClient.get<GetAllUsersResponse>(environment.v3BaseUrl + '/api/v3/admin-desktop/users', { headers }).toPromise();
  }

  async v3GetUserById(id: string): Promise<GetAllUsersResponse> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.httpClient.get<GetAllUsersResponse>(environment.v3BaseUrl + `/api/v3/admin-desktop/users?ids=${id}`, { headers }).toPromise();
  }

  async v3GetUserByIdWWithArray(id: string[]): Promise<GetAllUsersResponse> {
    const params = buildHttpParams({ ids: id });
    return this.httpClient.get<GetAllUsersResponse>(environment.v3BaseUrl + `/api/v3/admin-desktop/users`, { params }).toPromise();
  }
}

